import {
  Code2, Users, Clock3, Briefcase, Layers, Crown,
  Cpu, Wrench, Factory, Landmark, HeartPulse, ShoppingBag,
  Truck, Building2, LineChart, Boxes,
  Target, Search, ClipboardCheck, Handshake, UserCheck,
} from "lucide-react";

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Industries", to: "/#industries" },
  { label: "For Employers", to: "/employers" },
  { label: "For Candidates", to: "/careers" },
  { label: "Contact", to: "/contact" },
];

export const TRUST_POINTS = [
  { title: "Quality Talent", desc: "Carefully screened professionals aligned with your skills, experience and business requirements." },
  { title: "Faster Hiring", desc: "Technology-enabled sourcing and streamlined recruitment to help you hire faster." },
  { title: "IT & Non-IT Expertise", desc: "Specialized recruitment capabilities across technology and diverse business functions." },
  { title: "Scalable Partnerships", desc: "Flexible talent solutions that grow with your workforce and business needs." },
];

export const ABOUT_PILLARS = [
  { title: "Business-First Understanding", desc: "We take the time to understand your business, role requirements, culture and workforce needs before we begin the search." },
  { title: "People-Centric Approach", desc: "Great hiring works both ways. We create transparent and respectful experiences for candidates while helping clients connect with the right talent." },
  { title: "Relevant, Not Just More", desc: "Our focus is on quality over quantity — presenting professionals whose skills, experience and expectations genuinely align with the opportunity." },
  { title: "Responsive by Design", desc: "Clear communication, quick follow-ups and an agile recruitment process keep every hiring engagement moving forward." },
];

export const SERVICES = [
  { slug: "it-recruitment", icon: Code2, title: "IT Recruitment",
    short: "Software development, cloud, data, DevOps, cybersecurity, testing, infrastructure and other technology roles.",
    span: "lg:col-span-7" },
  { slug: "non-it-recruitment", icon: Users, title: "Non-IT Recruitment",
    short: "Recruitment across business, engineering, operations, finance, HR, sales, administration and other functions.",
    span: "lg:col-span-5" },
  { slug: "staffing-solutions", icon: Clock3, title: "Contract Staffing",
    short: "Flexible workforce solutions for organizations requiring skilled professionals for short-term or long-term assignments.",
    span: "lg:col-span-5" },
  { slug: "staffing-solutions", icon: Briefcase, title: "Permanent Staffing",
    short: "End-to-end recruitment support to help organizations hire the right permanent employees.",
    span: "lg:col-span-7" },
  { slug: "rpo-services", icon: Layers, title: "RPO Services",
    short: "Recruitment Process Outsourcing for companies looking for scalable and efficient hiring support.",
    span: "lg:col-span-7" },
  { slug: "it-recruitment", icon: Crown, title: "Executive Search",
    short: "Specialized search and talent acquisition for critical and senior-level positions.",
    span: "lg:col-span-5" },
];

export const INDUSTRIES = [
  { icon: Cpu, name: "Information Technology" },
  { icon: Wrench, name: "Engineering" },
  { icon: Factory, name: "Manufacturing" },
  { icon: Landmark, name: "Banking & Financial Services" },
  { icon: HeartPulse, name: "Healthcare" },
  { icon: ShoppingBag, name: "Retail" },
  { icon: Truck, name: "Logistics & Supply Chain" },
  { icon: Building2, name: "Construction & Infrastructure" },
  { icon: LineChart, name: "Professional Services" },
  { icon: Boxes, name: "Other Industries" },
];

export const PROCESS = [
  { no: "01", icon: Target, title: "Understand", desc: "Understand the role, business context, technical requirements and ideal candidate profile." },
  { no: "02", icon: Search, title: "Source", desc: "Identify and engage relevant talent through targeted sourcing and technology-enabled recruitment." },
  { no: "03", icon: ClipboardCheck, title: "Screen", desc: "Evaluate candidates against skills, experience, role requirements and organizational fit." },
  { no: "04", icon: Handshake, title: "Connect", desc: "Coordinate interviews, facilitate communication and support the hiring process." },
  { no: "05", icon: UserCheck, title: "Hire & Support", desc: "Support offer closure, onboarding and long-term talent relationships." },
];

export const WHY_SYNANI = [
  { title: "Industry-Focused Recruitment", desc: "Domain-aware recruiters who understand your industry's talent requirements and hiring landscape." },
  { title: "Cross-Functional Talent Expertise", desc: "One talent partner for technology, engineering, business, operations and other critical functions." },
  { title: "Structured Candidate Screening", desc: "Candidates are evaluated against role-specific skills, experience and hiring criteria before being presented." },
  { title: "Agile Hiring Support", desc: "Technology-enabled sourcing and structured workflows help accelerate the hiring process." },
  { title: "Transparent Communication", desc: "Clear, timely updates and open communication throughout every stage of the hiring process." },
  { title: "Long-Term Partnerships", desc: "We focus on building trusted relationships that support your evolving talent needs — not just filling individual vacancies." },
];

export const STATS = [
  { value: "[XX]+", label: "Candidates Placed" },
  { value: "[XX]+", label: "Clients Served" },
  { value: "[XX]+", label: "Open Positions" },
  { value: "[XX]+", label: "Industries Covered" },
];

export const TESTIMONIALS = [
  { name: "[Client Name]", role: "[Designation]", company: "[Company]",
    quote: "[Placeholder testimonial — replace with a real client quote about their hiring experience with SYNANI Talent Solutions.]" },
  { name: "[Client Name]", role: "[Designation]", company: "[Company]",
    quote: "[Placeholder testimonial — replace with a real client quote highlighting speed, quality or partnership.]" },
  { name: "[Client Name]", role: "[Designation]", company: "[Company]",
    quote: "[Placeholder testimonial — replace with a real client quote about the candidates SYNANI delivered.]" },
];

export const JOBS = [
  { title: "Senior Full-Stack Engineer", type: "Permanent", category: "IT", location: "Chennai / Remote", exp: "5-8 yrs" },
  { title: "DevOps Engineer", type: "Contract", category: "IT", location: "Bengaluru", exp: "4-7 yrs" },
  { title: "Data Analyst", type: "Permanent", category: "IT", location: "Hyderabad", exp: "2-5 yrs" },
  { title: "Cybersecurity Specialist", type: "Permanent", category: "IT", location: "Chennai", exp: "6-10 yrs" },
  { title: "Finance Manager", type: "Permanent", category: "Non-IT", location: "Mumbai", exp: "8-12 yrs" },
  { title: "Sales Lead — Enterprise", type: "Permanent", category: "Non-IT", location: "Delhi NCR", exp: "6-9 yrs" },
  { title: "HR Business Partner", type: "Contract", category: "Non-IT", location: "Chennai", exp: "4-6 yrs" },
  { title: "Operations Executive", type: "Permanent", category: "Non-IT", location: "Coimbatore", exp: "1-3 yrs" },
];

export const SERVICE_DETAILS = {
  "it-recruitment": {
    title: "IT Recruitment",
    kicker: "Technology Talent",
    intro: "We help technology teams hire specialised engineers and IT professionals across the full stack — from application development to infrastructure and security.",
    image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHx0ZWNobm9sb2d5JTIwcHJvZmVzc2lvbmFscyUyMHdvcmtpbmd8ZW58MHx8fHwxNzg3MDcwNDg1fDA&ixlib=rb-4.1.0&q=85",
    imageAlt: "Technology professionals collaborating in an office",
    items: ["Software Development", "Cloud & DevOps", "Data & Analytics", "Cybersecurity", "QA & Testing", "IT Infrastructure", "Product & Design", "Enterprise Applications"],
    keywords: "IT Recruitment Company, IT Staffing Services, IT Recruitment Services in India",
  },
  "non-it-recruitment": {
    title: "Non-IT Recruitment",
    kicker: "Business Talent",
    intro: "Beyond technology, we source proven professionals across core business functions — helping you build balanced, capable teams.",
    image: "https://images.pexels.com/photos/7108269/pexels-photo-7108269.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    imageAlt: "Recruitment consultants reviewing candidate profiles",
    items: ["Sales & Marketing", "Finance & Accounting", "Human Resources", "Operations", "Engineering", "Administration", "Customer Success", "Supply Chain"],
    keywords: "Non-IT Recruitment, Recruitment Consultancy, Talent Acquisition",
  },
  "staffing-solutions": {
    title: "Staffing Solutions",
    kicker: "Contract & Permanent",
    intro: "Flexible and permanent workforce solutions built around your business — whether you need to scale quickly or hire for the long term.",
    image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHx0ZWNobm9sb2d5JTIwcHJvZmVzc2lvbmFscyUyMHdvcmtpbmd8ZW58MHx8fHwxNzg3MDcwNDg1fDA&ixlib=rb-4.1.0&q=85",
    imageAlt: "Contract and permanent staffing team at work",
    items: ["Contract Staffing", "Contract-to-Hire", "Permanent Staffing", "Project-Based Teams", "Payroll Support", "Workforce Scaling", "Onsite & Remote", "Short & Long Term"],
    keywords: "Contract Staffing, Permanent Staffing, Staffing Solutions",
  },
  "rpo-services": {
    title: "RPO Services",
    kicker: "Recruitment Process Outsourcing",
    intro: "Scale your hiring without scaling your overheads. Our RPO model plugs directly into your talent function to deliver efficient, high-volume recruitment.",
    image: "https://images.pexels.com/photos/7108269/pexels-photo-7108269.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    imageAlt: "Recruitment process outsourcing team planning a hiring pipeline",
    items: ["End-to-End RPO", "Project RPO", "On-Demand Recruiters", "Employer Branding", "Sourcing Strategy", "Hiring Analytics", "Process Design", "Scalable Capacity"],
    keywords: "RPO Services, Recruitment Process Outsourcing, Staffing Solutions",
  },
};
